import { UpcomingInvoicesTable } from "@/features/invoices/upcoming-invoices-table";

const UpcomingInvoicesScreen = () => {
  return (
    <div className="p-4">
      <div className="mb-4">
        <h1 className="text-2xl font-bold">Upcoming Invoices</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Customers with pending orders approaching their invoice interval.
        </p>
      </div>
      <UpcomingInvoicesTable />
    </div>
  );
};

export default UpcomingInvoicesScreen;
